import classNames from 'classnames';
import * as React from 'react';
import { Collapse as ReactCollapse } from 'react-collapse';
import s from './Collapse.scss';
export const Collapse = ({ isOpened, children, onRest, onWork, initialStyling = {}, className, dataHook, }) => (React.createElement(ReactCollapse, { isOpened: isOpened, initialStyle: {
        height: 0,
        width: '100%',
        overflow: 'hidden',
        ...initialStyling,
    }, onRest: onRest, onWork: onWork, theme: { collapse: classNames(s.collapse, className) }, "data-hook": dataHook }, children));
//# sourceMappingURL=Collapse.js.map